import React from "react";
import ShippingOne from "../components/ShippingOne";
import BreadcrumbThree from "../components/BreadcrumbThree";
import TermsAndConditions from "../components/TermsAndConditions";
import { Helmet } from "react-helmet-async";

const TermsAndConditionsPage = () => {
  return (
    <>


      <Helmet>
        <title> Terms and Conditions | VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness</title>
      </Helmet>

      {/* Breadcrumb */}
      <BreadcrumbThree title={"Terms And Conditions"} />

      {/* Account */}
      <TermsAndConditions />

      {/* ShippingOne */}
      <ShippingOne />

    </>
  );
};

export default TermsAndConditionsPage;
